import * as React from 'react';
import Svg, {SvgProps, Rect, Path} from 'react-native-svg';

const SvgComponent = (props: SvgProps) => (
  <Svg width={30} height={30} viewBox={'0 0 30 30'} {...props} fill="none">
    <Rect
      x={0.707}
      y={15.556}
      width={21}
      height={21}
      rx={4.5}
      transform="rotate(-45 .707 15.556)"
      stroke={'#009F9C'}
    />
    <Path
      d="m20 13-5.5 5.6-2.5-2.546"
      stroke={'#009F9C'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

export default SvgComponent;
